<template>
  <section class="dark:bg-white">
    <!-- hero page -->
    <section
      class="h-[400px] md:h-[90vh] w-full isolate overflow-hidden bg-black relative"
    >
      <video class="h-full w-full relative" autoplay muted loop>
        <source src="/video/hero-vid.mp4" type="video/mp4" />
        <source src="/video/hero-vid.ogg" type="video/ogg" />
      </video>
      <div
        className="z-50 h-screen absolute card w-full bg-[#333] bg-opacity-80 inset-0 outline-none focus:outline-none"
      >
        <div
          class="w-full px-3 mx-auto flex items-center pt-60 sm:pt-40 md:pt-1 md:min-h-full"
        >
          <swiper
            :slidesPerView="1"
            :spaceBetween="50"
            :freeMode="true"
            :loop="true"
            :autoplay="{
              delay: 5000,
              disableOnInteraction: false,
            }"
            :modules="modules"
            class="mySwiper"
          >
            <swiper-slide
              class="flex justify-center items-center rounded-lg font-bold mx-auto text-white text-4xl sm:text-[100px] md:text-[150px] 2xl:text-[200px]"
            >
              <p>QUALITY</p>
            </swiper-slide>
            <swiper-slide
              class="flex justify-center items-center rounded-lg font-bold mx-auto text-white text-4xl sm:text-[100px] md:text-[150px] 2xl:text-[200px]"
            >
              <p>STRENGTH</p>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>

    <section class="text-primary flex justify-center">
      <div class="flex gap-10 flex-col lg:flex-row z-10 mt-20 lg:mt-[-100px]">
        <div
          class="p-20 animate__animated animate__fadeInUp animate__delay-1s text-center rounded-t-md md:h-[200px] w-full md:w-[400px] lg:h-full lg:w-full border-b-2 border-secondary shadow bg-white"
        >
          <h2
            class="font-bold text-5xl md:text-3xl lg:text-7xl capitalize text-secondary"
          >
            5<span class="font-normal text-3xl">+</span>
          </h2>
          <p class="pt-2">Quality Products</p>
        </div>
        <div
          class="p-20 animate__animated animate__fadeInUp animate__delay-2s text-center rounded-t-md md:h-[200px] w-full md:w-[400px] lg:h-full lg:w-full border-b-2 border-secondary shadow bg-white"
        >
          <h2
            class="font-bold text-5xl md:text-3xl lg:text-7xl capitalize text-secondary"
          >
            200<span class="font-normal text-3xl">+</span>
          </h2>
          <p class="pt-2">Happy customers</p>
        </div>
        <div
          class="p-20 animate__animated animate__fadeInUp animate__delay-3s text-center rounded-t-md md:h-[200px] w-full md:w-[400px] lg:h-full lg:w-full border-b-2 border-secondary shadow bg-white"
        >
          <h2
            class="font-bold text-5xl md:text-3xl lg:text-7xl capitalize text-secondary"
          >
            40<span class="font-normal text-3xl">+</span>
          </h2>
          <p class="pt-2">Global partners</p>
        </div>
      </div>
    </section>

    <!-- products -->

    <section class="mt-40">
      <h3
        class="text-black text-center uppercase pb-10 md:pb-20 text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold"
      >
        OUR PRODUCTS
        <span
          class="block border-t-4 border-secondary w-[100px] md:w-[200px] mt-3 mx-auto"
        ></span>
      </h3>

      <product-swiper></product-swiper>
    </section>

    <!-- About Us -->
    <section class="my-28 relative h-full">
      <div class="md:pt-20 relative">
        <div class="w-full lg:h-[50%] relative">
          <img
            src="images/hero-home.png"
            class="w-[50%] h-[40%] lg:h-[30%] hidden md:block object-contain rounded-r-[50px]"
            alt=""
          />
          <div
            class="w-full md:w-[100%] px-5 md:pl-0 md:min-h-full lg:w-[64%] bg-black md:absolute right-0 bottom-0 top-0 md:translate-y-28 rounded-l-[50px]"
          >
            <div
              class="flex justify-center h-full items-center py-20 lg:py-20 2xl:pt-40 px-10 md:px-0 md:w-[600px] mx-auto"
            >
              <div class="space-y-5 2xl:space-y-10">
                <h4
                  class="text-white animate__animated animate__fadeInUp animate__delay-1s text-xl md:text-2xl lg:text-3xl font-bold"
                >
                  ABOUT COMPANY
                  <span
                    class="block border-t-4 border-secondary w-[100px]"
                  ></span>
                </h4>
                <p
                  class="pt-3 animate__animated animate__fadeInRight animate__delay-2s mt-5 text-sm md:text-base lg:text-lg 2xl:text-xl"
                >
                  Since our inception, Lubx Engine Oil has been a beacon light
                  of innovation, dedication, and growth. Our journey is a
                  testament to the power of vision, hard work, and a relentless
                  commitment to excellence.
                </p>
                <p
                  class="pt-3 animate__animated animate__fadeInRight animate__delay-2s text-sm md:text-base lg:text-lg 2xl:text-xl"
                >
                  With operations primarily in the Automotive and Industrial
                  segments, and a leading presence in the open market through a
                  distributor network, we supply directly to other B2B customers
                  (Industries, Infrastructure, Mining & Fleet Customers, State
                  Transport and Government Undertakings).
                </p>
                <p
                  class="pt-3 animate__animated animate__fadeInRight animate__delay-2s text-sm md:text-base lg:text-lg 2xl:text-xl"
                >
                  We are one of the Fastest Growing Lubricant Player by
                  consistently outperforming the industry growth rate Year Over
                  Year
                </p>

                <div
                  class="animate__animated animate__fadeInRight animate__delay-3s text-sm md:text-base lg:text-lg 2xl:text-xl"
                >
                  <router-link to="/about">
                    <button
                      class="flex gap-5 items-center text-sm md:text-base lg:text-lg 2xl:text-xl hover:text-secondary"
                    >
                      Read more<span
                        ><img src="/icons/arrow-white.svg" alt=""
                      /></span>
                    </button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- News Letter -->

    <section class="my-20 md:mt-100 lg:mt-80 md:mb-40">
      <h3
        class="text-black text-2xl pb-10 md:text-3xl text-center lg:text-4xl font-bold"
      >
        Newsletter
        <span
          class="block border-t-4 border-secondary w-[100px] mt-3 mx-auto"
        ></span>
      </h3>
      <div class="w-full px-5 sm:w-[700px] mx-auto">
        <div class="flex flex-col gap-5 md:gap-10">
          <p class="text-black text-center text-sm sm:text-base md:text-xl">
            You can subscribe to our newsletter to constantly get up to date
            news from the downstream sector.
          </p>

          <label for="">
            <input
              type="text"
              name=""
              id=""
              class="v-input placeholder:lowercase border border-secondary text-text focus:outine-none"
              placeholder="name@gmail.com"
            />
          </label>

          <div
            class="mx-auto cursor-pointer h-[50px] w-[50px] border border-text rounded-full mt-5 p-2 flex items-center justify-center hover:border-secondary hover:bg-secondary"
          >
            <button><img src="/icons/arrow.svg" /></button>
          </div>
        </div>
      </div>
    </section>

    <partner-component />
  </section>
</template>

<script>
import "animate.css";
import PartnerComponent from "@/components/PartnerComponent.vue";
import ProductSwiper from "@/components/ProductSwiper.vue";
import "swiper/css/effect-fade";
import { Swiper, SwiperSlide } from "swiper/vue";
// Import Swiper styles
import "swiper/css";
// import required modules
import { Autoplay, EffectFade } from "swiper/modules";

// import "swiper/css/navigation";
// import "swiper/css/pagination";
// import HeroAnimate from "@/components/HeroAnimate.vue";

export default {
  name: "HomeView",
  components: {
    Swiper,
    SwiperSlide,
    PartnerComponent,
    ProductSwiper,
  },
  setup() {
    return {
      modules: [Autoplay, EffectFade],
    };
  },
};
</script>

<style scoped>
/*  */
.slide-out-fwd-center {
  animation: slide-out-fwd-center 0.7s cubic-bezier(0.55, 0.085, 0.68, 0.53)
    both;
}
.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
}

.swiper-slide p {
  display: block;
  width: 100%;
}
</style>
